module.exports = __webpack_public_path__ + "static/Curenseaw-5a013f79f722675798e1f4ced61bd7fc.jpg";